import { GKClientDataGrid, Grid2, Show, StatusField } from "components";
import { useState } from "react";
import { extraColumnsField, matchDate } from "utils/helpers";
import RecommendationTimelineModal from "./RecommendationTimelineModal";

const EquityBasketRecommendationHistory = ({
  stockRecommendations,
}: {
  stockRecommendations: any;
}) => {
  const [selectedRecommendation, setSelectedRecommendation] = useState(null);

  const [showRecommendationHistory, setShowRecommendationHistory] =
    useState(false);

  return (
    <>
      <Grid2 container>
        <Grid2 size={7}>
          <GKClientDataGrid
            disableRowSelectionOnClick
            showHeaderGrid={false}
            name="equityBasketRecommendationHistory"
            rows={stockRecommendations || []}
            onRowClick={(params) => {
              setShowRecommendationHistory(true);
              setSelectedRecommendation(params?.row?.id);
            }}
            columns={[
              {
                ...extraColumnsField("Rec. Date", "dateAdded", 1, 1),
                valueFormatter: (params) => matchDate(params.value),
              },
              {
                ...extraColumnsField("Status", "status", 1, 1),
                renderCell: (params) => {
                  return <StatusField statusString={params.row.status} />;
                },
              },
              {
                ...extraColumnsField("Completion Date", "completionDate", 1, 1),
              },
            ]}
          />
        </Grid2>
      </Grid2>
      <Show.When isTrue={showRecommendationHistory}>
        <RecommendationTimelineModal
          open={showRecommendationHistory}
          selectedRecommendation={selectedRecommendation}
          setOpen={setShowRecommendationHistory}
        />
      </Show.When>
    </>
  );
};

export default EquityBasketRecommendationHistory;
